<template>
  <button
    class="btn w-full"
    @click="createCheckout"
  >
    {{ callToAction }}
  </button>
</template>
<script>
export default {
  name: 'XnStripeCheckoutButton',
  props: {
    callToAction: { type: String, default: 'Checkout' },
    paymentMethods: {
      type: Array,
      default () {
        return ['card']
      },
    },
    isSubscription: { type: Boolean, default: false },
    quantity: { type: Number, default: 1 },
    currency: { type: String, default: 'usd' },
    taxRate: { type: [Number, null], default: null },
    cancelUrl: { type: String, default: null },
    successUrl: { type: String, default: null },
    payAmount: { type: [Number, null], default: null },
    name: { type: String, default: 'Stripe Transaction' },
    description: { type: String, default: 'A transaction' },
    priceId: { type: [String, null], default: null },
    accessId: { type: [String, null], default: null },
    checkoutMethod: {
      type: Function,
      default (
        paymentMethods,
        isSubscription,
        quantity,
        currency,
        cancelUrl,
        successUrl,
        payAmount,
        description,
        name,
        priceId,
        accessId,
        taxRate
      ) {
        return this.$api.Transactions.createCheckout(
          paymentMethods,
          isSubscription ? 'subscription' : 'payment',
          quantity,
          currency,
          cancelUrl,
          successUrl,
          payAmount,
          description,
          name,
          priceId,
          accessId,
          taxRate
        )
      },
    },
  },
  data () {
    return {
      waiting: false,
    }
  },
  methods: {
    createCheckout () {
      this.waiting = true
      this.checkoutMethod(
        this.paymentMethods,
        this.isSubscription,
        this.quantity,
        this.currency,
        this.cancelUrl,
        this.successUrl,
        this.payAmount,
        this.description,
        this.name,
        this.priceId,
        this.accessId,
        this.taxRate
      )
        .then(response => {
          if (response.status == 201) {
            window.open(response.data.route, '_blank', 'noopener')
          } else {
            throw new Error('Attempt to create checkout session failed')
          }
        })
        .then(() => {
          return
        })
        .catch(err => {
          alert('errors: ' + err.message)
        })
        .finally(() => {
          self.waiting = false
        })
    },
  },
}
</script>
<style scoped></style>
